import { render, staticRenderFns } from "./config-us.vue?vue&type=template&id=0a0c7219"
import script from "./config-us.vue?vue&type=script&lang=js"
export * from "./config-us.vue?vue&type=script&lang=js"
import style0 from "./config-us.vue?vue&type=style&index=0&id=0a0c7219&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports